const pages = {
  gallery: {
    eyebrow: 'Moments',
    title: 'Gallery',
    intro: 'Photographs from Črna Kuhna — fire, dishes, space and wine. We add them as we take them.',
    ctaTitle: 'Come to the shared table',
    ctaText: 'The gallery gives you a feel for it, but the scent of fire and the taste of Prlekija are only real in person. Book a table and come.',
    filters: { all: 'All', fire: 'Fire', dishes: 'From the menu', space: 'Space', wine: 'Wine' },
    categories: { fire: 'Fire', dishes: 'From the menu', space: 'Space', wine: 'Wine' },
    empty: 'There are no photographs in this category yet.',
    openLabel: 'Open photograph',
    closeLabel: 'Close',
    prevLabel: 'Previous',
    nextLabel: 'Next',
    photos: {
      oven: 'The bread oven with fire — the heart of our kitchen',
      grill: 'A grill with an open fire',
      carpaccio: 'Trout carpaccio with fresh peaches',
      soupNoodles: 'Homemade soup with noodles',
      pumpkinSoup: 'Creamy pumpkin soup with pumpkin seed oil',
      tomahawk: 'Tomahawk steak with a grilled side',
      dessert: 'Homemade dessert',
      preparation: 'Preparing a dish in the kitchen',
      chandelier: 'A detail of the space — a chandelier of green bottles',
      interior: 'The interior of Črna Kuhna',
      wine: 'A bottle of Traminec from the Glavinič cellar',
      team: 'The Črna Kuhna team in the restaurant',
      host: 'Our host at Črna Kuhna presenting dishes from our kitchen',
    },
    captions: {
      preparation: 'On special culinary evenings, the finest chefs of Slovenia join us at our table.',
    },
  },
  menu: {
    eyebrow: 'Menu',
    title: 'Seasonal menu',
    intro: 'The kitchen follows the seasons and the Prlekija soil. Dishes change through the year, so we do not fill the menu with invented content.',
    seasonalNotice: 'The seasonal menu changes',
    seasonalNoticeText: 'Please check the current offer by phone — we are happy to tell you what is on the table today.',
    emptyTitle: 'The menu is being prepared',
    emptyText: 'The offer will be published once confirmed. Until then we are happy to guide you by phone.',
    allergensTitle: 'Allergens and dietary options',
    allergensText: 'We list allergens with each dish. Tell us about allergies and dietary limits so we can prepare a dish to suit you.',
    dietaryText: 'For vegetarian, gluten-free and other adjustments, please let us know in advance.',
    pdfTitle: 'Menu as PDF',
    pdfText: 'A link to the PDF menu will be added once you provide it.',
    ctaCall: 'Call for the current menu',
    categoriesLabel: 'Categories',
    loading: 'Loading the menu …',
    error: 'The menu cannot be loaded right now.',
    retry: 'Try again',
  },
  reserve: {
    eyebrow: 'Reservation',
    title: 'Črna Kuhna',
    intro: 'Choose a date, time and number of guests. You can also book by phone or email.',
    bookingTitle: 'Booking system',
    bookingText: 'Reservations run through our online booking system. If you prefer, call us or send an email.',
    bookingPending: 'The booking system is being prepared. Until then, please book by phone or email.',
    bookingAreaLabel: 'The booking system will be embedded here',
    phoneTitle: 'By phone',
    phoneText: 'The quickest way to agree — call us and we will book your table.',
    emailTitle: 'By email',
    emailText: 'Write your date, time and number of guests, and we will confirm your reservation.',
    infoTitle: 'Good to know',
    infoItems: [
      'For larger groups, please announce your reservation in advance.',
      'Tell us about allergies and dietary limits when you book.',
      'For special occasions, let us know in advance so we can prepare everything.',
    ],
    groupText: 'Planning a private dinner or a larger group?',
    formTitle: 'Book a table',
    formIntro: 'Choose a date, time and number of guests and enter your details. We will confirm your reservation as soon as possible.',
    formName: 'Full name',
    formPhone: 'Phone',
    formEmail: 'Email (optional)',
    formDate: 'Date',
    formTime: 'Time',
    formTimePlaceholder: 'Choose a time',
    formGuests: 'Number of guests',
    formGuestsUnit: 'guests',
    formNotes: 'Note (optional)',
    formNotesPlaceholder: 'Special wishes, allergies, occasion …',
    formSubmit: 'Book a table',
    formSending: 'Sending …',
    formSuccessTitle: 'Reservation sent!',
    formSuccessText: 'Thank you! We have received your reservation. We will confirm it by phone or email as soon as possible.',
    formAnother: 'New reservation',
    formError: 'The reservation could not be sent. Please try again or call us.',
    formRequired: 'Please fill in your name, phone, date, time and number of guests.',
    formCharCount: 'up to 500 characters',
  },
  story: {
    eyebrow: 'Story',
    title: 'Our story',
    intro: 'Črna Kuhna grew out of the fire, the Prlekija soil and the wish for a shared table.',
    lead: 'At Črna Kuhna in Vinski Vrh, everything begins with the fire in our home bread oven. From seasonal ingredients from our own farm and from Prlekija suppliers, we prepare dishes served with the Glavinič house wines. Come, sit at the table and taste Prlekija.',
    fireTitle: 'Fire as the starting point',
    fireText: 'Cooking with us begins at the fire. The bread oven is not a backdrop but the heart of the kitchen — in it, dishes are roasted slowly, with a feel for heat and time.',
    firePhotoLabel: 'Photograph — the bread oven with fire',
    localTitle: 'Soil and seasons',
    localText: 'Our aim is to follow the seasons and the Prlekija soil and to work with local growers and winemakers.',
    valuesTitle: 'What matters to us',
    values: [
      'We tell you exactly what is on the plate — no inventions.',
      'We respect the season and do not promise what is not there.',
      'The table is shared: room for talk, a glass and time.',
    ],
    chaptersLabel: 'Chapters',
    chaptersTitle: 'Explore our story',
    chaptersText: 'Click a chapter and it opens — the image and the word appear as if from the fire.',
    chaptersHint: 'Click to open',
  },
  wines: {
    eyebrow: 'Wines',
    title: 'Wines and Vinski raj Glavinič',
    intro: 'The house wines come from the Prlekija vineyards, where the wine grows right beside the dish.',
    houseTitle: 'Glavinič house wines',
    houseText: 'We serve the Glavinič house wines with the meal. We will talk you through the pairing and recommend a glass that suits your dish.',
    tastingTitle: 'Tastings',
    tastingText: 'Tastings and guided wine flights are arranged in advance. They can be paired with food from the bread oven.',
    externalTitle: 'Glavinič winery',
    externalText: 'For more about Glavinič wines, see their own pages or search for them online.',
    externalCta: 'Search for Vinski raj Glavinič',
    photoLabel: 'Photograph — wine, glasses or vineyards',
    listTitle: 'Wine list',
    listIntro: 'A selection of wines from Prlekija cellars that pair with our kitchen.',
    whiteTitle: 'White wines',
    redTitle: 'Red wines',
    wineryLabel: 'Winery',
  },
  visit: {
    eyebrow: 'Visit',
    title: 'Visit and contact',
    intro: 'You will find us among the Prlekija hills and vineyards. The button below opens directions to us.',
    regionBadge: 'Jeruzalem Hills',
    regionTitle: 'In the heart of the Jeruzalem Hills',
    regionText: 'Our kitchen sits in the Jeruzalem wine region — among the vineyards of the Jeruzalem Hills, just above Miklavž pri Ormožu. Here, wine and food are at home.',
    addressTitle: 'Address',
    mapTitle: 'Map',
    directionsCta: 'Open directions',
    phoneTitle: 'Phone',
    emailTitle: 'Email',
    hoursTitle: 'Winter opening hours',
    hoursText: 'Open Thursday to Sunday; closed Monday to Wednesday.',
    socialTitle: 'Social media',
    socialText: 'We will add the Instagram link once you provide it.',
    groupText: 'For larger groups and private occasions, give us a call.',
  },
  events: {
    eyebrow: 'Events',
    title: 'Events and private dinners',
    intro: 'For private dinners, family celebrations and business gatherings we set the table around your occasion.',
    typesTitle: 'What we can plan',
    types: [
      'Private dinners by the fire',
      'Family celebrations and anniversaries',
      'Business gatherings and closed groups',
      'Tastings with wine pairing',
    ],
    enquiryTitle: 'Enquiry',
    enquiryText: 'Tell us what you are planning and we will reply with a suggestion and the details.',
    formName: 'Full name',
    formEmail: 'Email',
    formPhone: 'Phone',
    formType: 'Type of event',
    formTypeOptions: ['Private dinner', 'Family celebration', 'Business gathering', 'Tasting', 'Other'],
    formDate: 'Approximate date',
    formGuests: 'Number of guests',
    formMessage: 'Message',
    formMessagePlaceholder: 'Describe the occasion, your wishes and anything specific …',
    formSubmit: 'Send enquiry',
    formSending: 'Sending …',
    formSuccess: 'Thank you! Your enquiry has been sent — we will get back to you as soon as possible.',
    formError: 'The enquiry could not be sent. Please try again or call us.',
    formRequired: 'Please fill in the required fields.',
    formCharCount: 'up to 500 characters',
  },
  gift: {
    eyebrow: 'Gift',
    title: 'Gift vouchers',
    intro: 'Give a meal at Črna Kuhna — for a celebration, a thank you or simply for joy.',
    howTitle: 'How to get a gift voucher',
    howText: 'We arrange gift vouchers by phone or email. We will tell you what is possible right now and agree on how to issue it.',
    valueTitle: 'Value and validity',
    valueText: 'The value and validity of the voucher are agreed at purchase, so they match your wish.',
    ctaTitle: 'Order a gift voucher',
    ctaText: 'Call us or send an email and we will prepare a voucher to suit you.',
    photoLabel: 'Photograph — a gift voucher or the table',
    vouchersTitle: 'Gift vouchers worth €50 or €100',
    vouchersText: 'The choice is simple. You can buy the gift voucher right at the bar counter in the restaurant and pass it on with joy — for a celebration, a thank you or simply for pleasure.',
    voucherName: 'Gift voucher',
    voucherBuyLabel: 'Available at the bar counter in the restaurant',
    voucherBuyNote: 'You receive the voucher right away when you buy it at the bar counter. It is valid for all dishes and drinks from our offer.',
  },
  privacy: {
    eyebrow: 'Legal',
    title: 'Privacy policy',
    intro: 'We use your data only for the purpose you entrusted it to us for.',
    sections: [
      { title: 'What data we collect', body: 'Data you enter in the forms on our site (for example name, email, phone and the content of your message), and data you provide when booking or enquiring.' },
      { title: 'Why we use it', body: 'We use the data to answer your enquiry, to carry out your reservation and to communicate about your visit.' },
      { title: 'Storage and security', body: 'We keep data only as long as needed for the purpose it was collected for, and we protect it against unauthorised access.' },
      { title: 'Your rights', body: 'You have the right to access, correct and delete your data, and to object to processing. Contact us to exercise these rights.' },
      { title: 'Cookies', body: 'The site uses only the technologies necessary for it to work and to store your language choice.' },
    ],
    contactNote: 'For questions about privacy, contact us:',
  },
  terms: {
    eyebrow: 'Legal',
    title: 'Terms of use',
    intro: 'By using this site you agree to the following terms.',
    sections: [
      { title: 'Site content', body: 'The content is published in good faith and may change. The menu, opening hours and offer change; please check current information with us.' },
      { title: 'Reservations', body: 'A reservation is valid once confirmed. Please let us know about a change or cancellation as early as possible.' },
      { title: 'External links', body: 'The site may contain links to external pages, for whose content we are not responsible.' },
      { title: 'Copyright', body: 'The content and look of the site are protected. Use without permission is not allowed.' },
    ],
    contactNote: 'For questions, contact us:',
  },
};

export default { pages };